import React from "react";
import { Box, HStack, Stack, Text } from "@chakra-ui/react";
import WamStatusBadge from "./WamStatusBadge";


const WamSectionCard = ({
  title,
  subtitle,
  children,
  actions = null,
  status = "",
  statusLabel = "",
  minH,
  variant = "default",
  ...rest
}) => {
  const bg = variant === "highlight" ? "linear-gradient(180deg, rgba(37,99,235,0.06) 0%, rgba(255,255,255,0.98) 100%)" : "wam.card.bg";

  return (
    <Box
      w="full"
      maxW="100%"
      minW={0}
      borderWidth="1px"
      borderColor="wam.border"
      borderRadius="26px"
      bg={variant === "highlight" ? undefined : bg}
      background={variant === "highlight" ? bg : undefined}
      px={{ base: 4, md: 4 }}
      py={{ base: 4, md: 4 }}
      boxShadow="0 14px 30px rgba(15, 23, 42, 0.05)"
      minH={minH}
      {...rest}
    >
      <Stack spacing={3} w="full" minW={0}>
        {(title || subtitle || actions || status) ? (
          <HStack justify="space-between" align="flex-start" spacing={4} w="full" flexWrap="wrap">
            <Stack spacing={1} minW="0">
              {title ? (
                <Text as="h3" fontSize={{ base: "md", md: "lg" }} fontWeight="800" color="wam.text.primary" lineHeight="1.2" wordBreak="break-word">
                  {title}
                </Text>
              ) : null}
              {subtitle ? (
                <Text fontSize="sm" color="wam.text.secondary" wordBreak="break-word">
                  {subtitle}
                </Text>
              ) : null}
            </Stack>
            <HStack spacing={2} flexWrap="wrap" justify="flex-end" minW="0">
              {status ? <WamStatusBadge status={status} label={statusLabel} /> : null}
              {actions}
            </HStack>
          </HStack>
        ) : null}
        {children}
      </Stack>
    </Box>
  );
};


export default WamSectionCard;
